import env from '../services/AppEnv';
import { cloneDeep } from 'lodash';
import { isGranted } from "../services/AccessManager";
import log from "../services/Logger";
import trans from "../services/Translator";
import formUtils from "../components/form/FormUtils";
import alerts from "../services/Alerts";
const checkPermission = (to, from, next) => {
    const nearestWithPermission = to.matched.slice()
        .reverse()
        .find(r => r.meta && r.meta.permission);
    if (nearestWithPermission && !isGranted(nearestWithPermission.meta['permission'])) {
        alerts.error(trans('app.security_error'), trans('app.security_error.access_denied'));
        next('');
        return;
    }
    next();
};
const checkDirtyForms = (to, from, next) => {
    if (!formUtils.confirmDirtyForms()) {
        next(false);
        return;
    }
    next();
};
const updatePageTitle = (to, from, next) => {
    try {
        const nearestWithTitle = to.matched.slice()
            .reverse()
            .find(r => r.meta && r.meta.title);
        setPageTitle(nearestWithTitle ? trans(nearestWithTitle.meta['title']) : null);
    }
    catch (e) {
        log(e);
    }
    next();
};
const setPageTitle = (title) => {
    const defaultTitle = env.app.title;
    document.title = `${title || ''}${title ? ' - ' : ''}${defaultTitle}`;
};
function singleParam(route, key) {
    const val = route.params[key];
    return Array.isArray(val) ? val[0] : val;
}
export function resolveRouteParams(_params, item) {
    const params = cloneDeep(_params);
    Object.keys(params).forEach(param => {
        if (params[param].indexOf('{') === 0) {
            const prop = params[param].substring(1, params[param].length - 1);
            if (item[prop]) {
                params[param] = item[prop];
            }
            else {
                delete params[param];
            }
        }
    });
    return params;
}
export default {
    updatePageTitle: updatePageTitle,
    setPageTitle: setPageTitle,
    checkPermission: checkPermission,
    checkDirtyForms: checkDirtyForms,
    singleParam: singleParam,
    resolveRouteParams: resolveRouteParams,
};
